var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { r as registerInstance, h } from './core-6f498fd9.js';
var CsmSortableListDemo = /** @class */ (function () {
    function CsmSortableListDemo(hostRef) {
        registerInstance(this, hostRef);
        this.selectedItems = [
            { value: 'elementB', name: 'elementB' },
            { value: 'elementA', name: 'elementA' },
            { value: 'elementC', name: 'elementC' },
            { value: 'elementD', name: 'elementD' },
        ];
        this.unselectedItems = [
            { value: 'element2', name: 'element2' },
            { value: 'element3', name: 'element3' },
            { value: 'element1', name: 'element1' },
            { value: 'element4', name: 'element4' },
        ];
    }
    CsmSortableListDemo.prototype.removeFromSelectedItem = function (item) {
        var index = this.selectedItems.indexOf(item);
        if (index !== -1) {
            this.selectedItems.splice(index, 1);
        }
    };
    CsmSortableListDemo.prototype.removeFromUnselectedItem = function (item) {
        var index = this.unselectedItems.indexOf(item);
        if (index !== -1) {
            this.unselectedItems.splice(index, 1);
        }
    };
    CsmSortableListDemo.prototype.addToSelectedList = function (item, indexToInsert) {
        if (indexToInsert === void 0) { indexToInsert = 0; }
        if (item) {
            this.removeFromSelectedItem(item);
            this.removeFromUnselectedItem(item);
            this.selectedItems.splice(indexToInsert, 0, item);
        }
        this.selectedItems = __spreadArrays(this.selectedItems);
    };
    CsmSortableListDemo.prototype.sortSelectedList = function (event) {
        var _this = this;
        var keys = event.detail;
        this.selectedItems = keys.map(function (key) { return __spreadArrays(_this.selectedItems, _this.unselectedItems).find(function (item) { return item.value === key; }); });
        this.unselectedItems = this.unselectedItems.filter(function (item) { return keys.indexOf(item.value) === -1; });
    };
    CsmSortableListDemo.prototype.sortUnselectedList = function (event) {
        var _this = this;
        var keys = event.detail;
        this.unselectedItems = keys.map(function (key) { return __spreadArrays(_this.unselectedItems, _this.selectedItems).find(function (item) { return item.value === key; }); });
        this.selectedItems = this.selectedItems.filter(function (item) { return keys.indexOf(item.value) === -1; });
    };
    CsmSortableListDemo.prototype.addToUnselectedList = function (item, indexToInsert) {
        if (indexToInsert === void 0) { indexToInsert = 0; }
        if (item) {
            this.removeFromSelectedItem(item);
            this.removeFromUnselectedItem(item);
            this.unselectedItems.splice(indexToInsert, 0, item);
        }
        this.unselectedItems = __spreadArrays(this.unselectedItems);
    };
    CsmSortableListDemo.prototype.renderSortableItem = function (isSelected, onCheckboxChange, group) {
        var _this = this;
        return function (item, index) {
            return (h("csm-sortable-item", { key: "" + item.value, "data-key": "" + item.value, "data-selected": isSelected, "data-index": index, group: group }, h("csm-checkbox", { checked: isSelected, onCsmChange: onCheckboxChange.bind(_this, item) }), h("csm-label", null, item.name)));
        };
    };
    CsmSortableListDemo.prototype.render = function () {
        var selectedItemsKey = this.selectedItems.map(function (item) { return item.name; });
        var selectedItems = this.selectedItems.map(this.renderSortableItem(true, this.addToUnselectedList, selectedItemsKey.toString()));
        var unselectedItemsKey = this.unselectedItems.map(function (item) { return item.name; });
        var unselectedItems = this.unselectedItems.map(this.renderSortableItem(false, this.addToSelectedList, unselectedItemsKey.toString()));
        return (h("div", { style: { height: '426px', display: 'flex' } }, h("br", null), h("csm-sortable-list", { style: { minWidth: '250px', marginRight: '20px' }, sortedKeys: selectedItemsKey, onCsmSort: this.sortSelectedList.bind(this) }, selectedItems), h("br", null), h("csm-sortable-list", { style: { minWidth: '250px' }, sortedKeys: unselectedItemsKey, onCsmSort: this.sortUnselectedList.bind(this) }, unselectedItems)));
    };
    Object.defineProperty(CsmSortableListDemo, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}csm-checkbox{margin-right:8px}label{display:block}"; },
        enumerable: true,
        configurable: true
    });
    return CsmSortableListDemo;
}());
export { CsmSortableListDemo as csm_sortable_list_demo };
